import {Button, Col, Form, Input, InputNumber, Row, Select} from "antd";
import {FilterOutlined, SearchOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {HttpService} from "../../services/http/Http.service";
import {HttpErrorService} from "../../services/http/HttpError.service";
import {SendStatusLabel, SendStatusType, StatusCodeE, SUSPENSION_REASON_LABELS, TYPE_LABELS} from "../../model/models"

interface FilterFormProps {
    onFilter?: (values: any) => void,
    simulator?: any,
    selectedStatus?: StatusCodeE | null;
}

export default function FilterForm({onFilter, simulator, selectedStatus}: FilterFormProps) {
    const [form] = Form.useForm();
    const [formDisabled, setFormDisabled] = useState(true);

    const [exemptionCodes, setExemptionCodes] = useState()
    useEffect(() => {
        const fetchExemptionCodes = async () => {
            try {
                const data = await HttpService.getInstanceAxios().get('/exemption/list')
                setExemptionCodes(data.data.map((code: string) => ({
                    label: code,
                    value: code,
                })))
            } catch (error) {
                HttpErrorService.handle("Errore durante il recupero dei codici esenzione", error, true)
            }
        }
        fetchExemptionCodes()
    }, []);

    const [years, setYears] = useState()
    useEffect(() => {
        const fetchYears = async () => {
            try {
                const data = await HttpService.getInstanceAxios().get('/file-ts/get-combinator-years')
                setYears(data.data.map((year: string) => ({
                    label: year,
                    value: year,
                })))
            } catch (error) {
                HttpErrorService.handle("Errore durante il recupero degli anni", error, true)
            }
        }
        fetchYears()
    }, []);

    //If status is not sospese we do not need the motivation filter.
    useEffect(() => {
        if (selectedStatus !== StatusCodeE.SOSPESE) {
            form.setFieldsValue({motivation: undefined});
        }
    }, [selectedStatus, form]);
    const handleOnFinish = () => {
        const values = form.getFieldsValue();
        if (onFilter) {
            onFilter({
                selectedCodes: values.selectedCodes || simulator?.codes,
                selectedYears: values.selectedYears,
                amountFrom: values.amountFrom || simulator?.amount?.[0],
                amountTo: values.amountTo || simulator?.amount?.[1],
                fiscalCode: values.fiscalCode,
                fullName: values.fullName,
                fileType: values.fileType,
                suspensionMotivation: selectedStatus !== StatusCodeE.SOSPESE ? null : values.motivation,
                sendStatus : values.sendStatus
            });
        }
    };

    const motivationOptions = Object.entries(SUSPENSION_REASON_LABELS).map(([value, label]) => ({
        label, value
    }));


     const SendStatusLabelNotifica: Record<string, string> = {
         "-":"Nessuno",
        "TO_BE_SENT":"Da inviare" ,
        "IN_VALIDATION":"In fase di validazione" ,
        "ACCEPTED":"Accettata",
        "REFUSED":"Rifiutata",
        "DELIVERING":"Invio in corso" ,
        "DELIVERED":"Consegnata" ,
        "PAID":"Pagata",
        "UNREACHABLE":"Irreperibile",
        "CANCELLED":"Annullata",
        "RETURNED_TO_SENDER": "Restituita al mittente"
    };

    const sendStatusOptions = Object.entries(SendStatusLabelNotifica).map(([value, label]) => ({
        label, value
    }))

    const typeOptions = Object.entries(TYPE_LABELS).map(([value, label]) => ({
        label, value
    }));

    return (
        <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
            <Button
                type="primary"
                icon={<FilterOutlined/>}
                onClick={() => {
                    const newDisabled = !formDisabled;
                    setFormDisabled(newDisabled);

                    if (newDisabled) {
                        form.resetFields();
                    }
                }}
            />
            <Form style={{flexGrow: 1}} disabled={formDisabled} form={form} layout="vertical" onFinish={handleOnFinish}>
                <Row gutter={16} align="bottom">
                    <Col>
                        <Form.Item name="selectedCodes" label="Codice Esenzione">
                            <Select mode="multiple" allowClear placeholder="Codice/i" options={exemptionCodes}/>
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item name="selectedYears" label="Anno">
                            <Select
                                mode="multiple"
                                allowClear
                                placeholder="Anno/i"
                                options={years}/>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item name="amountFrom" label="Importo">
                            <InputNumber placeholder="Da"/>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item name="amountTo">
                            <InputNumber placeholder="A"/>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item name="fiscalCode" label="Codice Fiscale">
                            <Input placeholder="Codice Fiscale"/>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item name="fullName" label="Cognome Nome">
                            <Input placeholder="Cognome Nome"/>
                        </Form.Item>
                    </Col>

                    <Col>
                        <Form.Item name="fileType" label="Tipo">
                            <Select allowClear
                                    placeholder="Tipo"
                                    options={typeOptions}
                                    style={{minWidth: 160}}
                            />
                        </Form.Item>
                    </Col>

                    {selectedStatus === StatusCodeE.SOSPESE && (
                        <Col>
                            <Form.Item name="motivation" label="Motivazione di sospensione">
                                <Select allowClear
                                        placeholder="Motivazione"
                                        options={motivationOptions}
                                        style={{minWidth: 220}}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    {selectedStatus === StatusCodeE.NOTIFICA && (
                        <Col>
                            <Form.Item name="sendStatus" label="Stato Send">
                                <Select allowClear
                                        placeholder="Stato Send"
                                        options={sendStatusOptions}
                                        style={{minWidth: 200}}
                                />
                            </Form.Item>
                        </Col>
                    )}

                    <Col>
                        <Form.Item>
                            <Button icon={<SearchOutlined/>} type="primary" htmlType="submit"/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
